<template>
  <div class="dataTables_paginate paging_simple_numbers">
    <ul class="pagination pagination-rounded mb-0">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="m-0"
      ></b-pagination>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    value: {
      type: Number,
      required: true
    },
    totalRows: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
}
</script>

<style scoped>
/* Pagination custom classes */
::v-deep .pagination {
  justify-content: center !important;
}

::v-deep .pagination .page-item .page-link {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 34px !important;
  height: 34px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  border: 1px solid var(--outline-variant, #bfcaba) !important;
  color: var(--color-public-primary, #2e7d32) !important;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-weight: 600;
  font-size: 13px;
  margin: 0 3px;
  line-height: 1 !important;
  box-shadow: none !important;
}

::v-deep .pagination .page-item.active .page-link {
  background-color: var(--color-public-primary, #2e7d32) !important;
  border-color: var(--color-public-primary, #2e7d32) !important;
  color: #ffffff !important;
}

::v-deep .pagination .page-item:not(.active) .page-link:hover {
  background-color: rgba(46, 125, 50, 0.08) !important;
  border-color: var(--color-public-primary, #2e7d32) !important;
}
</style>
